import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";
import PriceDisplay from "../../containers/PriceDisplay";
import { Button } from "../common";

class DealThumbNailCustom extends React.Component {
  render = () => {
    const {
      titles,
      isIE,
      discountClubConfig,
      clubUserLoggedIn,
      isMobileView,
      product
    } = this.props;
    const showClubPrices =
      discountClubConfig && discountClubConfig.Active && !clubUserLoggedIn;
    return (
      <div className={styles.deal}>
        <div className={cx(styles.dealTitle, { [styles.ieIsShit]: isIE })}>
          {product.name}
        </div>
        <div
          className={cx(styles.dealDates, {
            [styles.mobileView]: isMobileView
          })}
        >
          <span className={styles.dealDatesTitle}>
            {titles.DealValidInDates} &nbsp;
          </span>
          {product.startDate + " - " + product.endDate}
        </div>
        <hr className={styles.dealPriceSeparator} />
        <div className={styles.dealPrice}>
          {titles.StartingFrom}
          {product.oldPrice > 0 && (
            <span className={styles.dealPriceOld}>
              <PriceDisplay
                price={product.oldPrice}
                currentCurrencyCode={product.currencyCode}
                fallBackCurrencySymbol={product.currency}
              >
                {price => price}
              </PriceDisplay>
            </span>
          )}
          <span className={styles.dealPriceNew}>
            <PriceDisplay
              price={product.lowestPrice}
              currentCurrencyCode={product.currencyCode}
              fallBackCurrencySymbol={product.currency}
            >
              {price => price}
            </PriceDisplay>
          </span>
          {titles.ForNight}
        </div>
        {showClubPrices && (
          <div
            className={cx(styles.dealClubMemeber, {
              [styles.dealClubMemeberIeIsShit]: isIE
            })}
          >
            <PriceDisplay
              price={product.simpleClubTotalPrice}
              currentCurrencyCode={product.currencyCode}
              fallBackCurrencySymbol={product.currency}
            >
              {price => price + " " + titles.SpecialPriceForClubMemeber}
            </PriceDisplay>
          </div>
        )}
        <Button className={styles.dealButton} title={titles.Checkout} />
      </div>
    );
  };
}

DealThumbNailCustom.propTypes = {
  titles: PropTypes.object,
  product: PropTypes.object,
  isIE: PropTypes.bool,
  discountClubConfig: PropTypes.object,
  clubUserLoggedIn: PropTypes.bool,
  isMobileView: PropTypes.bool
};

export default DealThumbNailCustom;



// WEBPACK FOOTER //
// ./src/components/DealThumbNailCustom/DealThumbNailCustom.js